/** Custom error class for assertion failures */
export class AssertionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "AssertionError";
  }
}

/**
 * Assert a condition is true, throwing an error if it is not.
 *
 * @example
 * assert(workflowId, "No workflowId found.");
 */
export function assert(condition: unknown, message: string): asserts condition {
  if (!condition) {
    throw new AssertionError(message);
  }
}

/**
 * Assert a value is never used, throwing an error if it is.
 *
 * @example
 * assertNever(value, "Value should never be used.");
 */
export function assertNever(_value: never, message: string): never {
  throw new AssertionError(message);
}
